/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-2016 Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React, { Component, PropTypes } from 'react';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './Navigation.css';
import { Link } from 'react-router';
import $ from 'jquery';

@withStyles(s)
export default class Navigation extends Component {

    constructor(props) {
        super(props);

        this.state = {
            cancelClick: false,
        };

        this.ClickCancel = this.ClickCancel.bind(this);
    }

    componentDidMount(){
        window.addEventListener('scroll', this.StickyHeader);
    }

    ClickCancel(e){

        $('#svgCancel').addClass('flipOutX');
        $('.wrapResponsiveNav').delay(600).fadeOut('slow');
        $('.bar.first').stop(true, true).delay(800).animate({y: 0}, 300);
        $('.bar.last').stop(true, true).delay(800).animate({y: 28}, 300);

    }

    render(){
        
        return (
            <div className={`wrapResponsiveNav`} >
                <div className={`responsiveNav`}>
                    <div className={`content`}>
                        <div className={`wrapNavSocial`}>
                            <nav>
                                <ul className={`topMenu`}>
                                    <li>
                                        <span>Québec : <a href="#">514-555-5555</a></span><br /><br />
                                        <span>Brossard : <a href="#">514-555-5555</a></span>
                                    </li>
                                    <li><a href="#" className={`iconHeader iconFacebook fa fa-facebook`}></a></li>
                                    <li><a href="#" className={`iconHeader iconInstagram fa fa-instagram`}></a></li>
                                    <li><a href="#" className={`iconHeader iconYoutube fa fa-youtube-play`}></a></li>
                                    <li><a href="#" className={`iconHeader iconSnapchat fa fa-snapchat-ghost`}></a></li>
                                </ul>
                            </nav>
                            <div className={`cancel`} onClick={this.ClickCancel}>
                                <svg id="svgCancel" x="0px" y="0px" width="40px" height="40px" viewBox="0 0 40 40" enableBackground="new 0 0 40 40">
                                    <rect className={`bar`} x="-4.5" y="16.5" transform="matrix(0.7071 0.7071 -0.7071 0.7071 19.9999 -8.2844)" fill="#FFFFFF" width="49" height="7"/>
                                    <rect className={`bar`} x="-4.5" y="16.5" transform="matrix(0.7071 -0.7071 0.7071 0.7071 -8.2844 20.0001)" fill="#FFFFFF" width="49" height="7"/>
                                </svg>
                            </div>
                        </div>
                        <div className={`wrapMainNav`} role="navigation">
                            <nav>
                                <ul>
                                    <li><Link to="/">Agence</Link></li>
                                    <li><Link to="/approche">Approche</Link></li>
                                    <li><Link to="/">Expertise</Link></li>
                                    <li><Link to="/">Réalisation</Link></li>
                                    <li><Link to="/blogue">Blogue</Link></li>
                                    <li><Link to="/contact">Contact</Link></li>
                                    <li><Link to="/services">Services</Link></li>
                                </ul>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./components/Navigation/Navigation.js